import { gettext } from '@eventbrite/i18n';

export const START_PUBLISH_DATE_REQUIRED = gettext(
    'Start publish date is required.',
);
export const START_PUBLISH_TIME_REQUIRED = gettext(
    'Start publish time is required.',
);

export const MIN_TIME_REQUIRED = gettext(
    'Publish time must be at least 10 minutes in the future.',
);
export const COYOTE_NAV_OPTIONS_PATH = '/manage/events';
export const GA_TRACKING_EVENT_CATEGORY = 'workspace-event';
export const SCHEDULED_LABEL = 'scheduled';

export const SALES_STATUS_ON_SALE = 'on_sale';
export const SALES_STATUS_NOT_YET_ON_SALE = 'not_yet_on_sale';
export const SALES_STATUS_NOT_YET_ON_SALE_ACCESS_CODED =
    'not_yet_on_sale_access_coded';
export const SALES_STATUS_SOLD_OUT = 'sold_out';
export const SALES_STATUS_UNAVAILABLE = 'unavailable';
export const STATE_RESOURCE_CACHE_NAME = 'resourceCache';

export const ENV_BASE_URL = (serverUrl: string) =>
    `${serverUrl}${COYOTE_NAV_OPTIONS_PATH}`;

export const OK_LABEL = gettext('Ok');

export const STORAGE_EVENT_KEY = 'current-event';
